"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageFile = exports.loop = void 0;
/* Package Imports */
var classnames_1 = __importDefault(require("classnames"));
var filesize_1 = __importDefault(require("filesize"));
var react_1 = __importStar(require("react"));
var models_1 = require("@app/_state/models");
var PackageProgressBar_1 = require("@app/components/packages/PackageProgressBar");
var PackageProgressDetails_1 = require("@app/components/packages/PackageProgressDetails");
var PauseButton_1 = require("@app/components/packages/PauseButton");
var RetryButton_1 = require("@app/components/packages/RetryButton");
var log_1 = __importDefault(require("@app/shared/log"));
var utils_1 = require("@app/shared/utils");
/**
 * Recursively iterates through an array of PackageFileModels and renders PackageFile components
 * @param files
 * @param eventEmitter
 * @param asperaEnabled
 * @param downloadEnabled
 * @param downloadSizeLimitInMB
 * @param encryptedPackage
 * @param fileStatus
 * @param httpGatewayStatus
 * @param onDownload
 * @param onOpenDownload
 * @param onRetry
 * @param onStop
 * @param packageSize
 * @param rootLevel
 */
var loop = function (files, eventEmitter, asperaEnabled, downloadEnabled, downloadSizeLimitInMB, encryptedPackage, fileStatus, httpGatewayStatus, onDownload, onOpenDownload, onRetry, onStop, packageSize, rootLevel) {
    var containsFolders = false;
    files.forEach(function (f) {
        if (!f.isLeaf) {
            containsFolders = true;
        }
    });
    return files.map(function (f) {
        return react_1.default.createElement(PackageFile, { key: f.name, file: f, eventEmitter: eventEmitter, asperaEnabled: asperaEnabled, containsFolders: containsFolders, downloadEnabled: downloadEnabled, downloadSizeLimitInMB: downloadSizeLimitInMB, encryptedPackage: encryptedPackage, fileStatus: fileStatus, httpGatewayStatus: httpGatewayStatus, onDownload: onDownload, onOpenDownload: onOpenDownload, onRetry: onRetry, onStop: onStop, packageSize: packageSize, rootLevel: rootLevel });
    });
};
exports.loop = loop;
/**
 * Blast's Package File component, displays the details for an individual file within a package
 */
var PackageFile = /** @class */ (function (_super) {
    __extends(PackageFile, _super);
    function PackageFile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isChecked: false };
        /* Component Lifecycle Methods - end */
        /* Component Methods - begin */
        _this.handleDownload = function (file) {
            if (file.fileTransferId) {
                if (_this.props.asperaEnabled) {
                    _this.props.onRetry(file);
                }
                else {
                    _this.props.onDownload(file);
                }
            }
            else {
                _this.props.onDownload(file);
            }
        };
        _this.handleDownloadStop = function (file) {
            if (file.fileTransferId) {
                _this.props.onStop(file);
            }
            else {
                log_1.default.debug("Unable to stop transfer of '" + file.path + "'");
            }
        };
        _this.handleExpand = function () {
            if (_this.props.file.isCollapsed) {
                _this.props.eventEmitter.emit('expand', _this.props.file, true);
            }
            else {
                _this.props.eventEmitter.emit('collapse', _this.props.file);
            }
        };
        _this.handleSelect = function () {
            _this.setState(function (prevState) {
                return __assign(__assign({}, prevState), { isChecked: !prevState.isChecked });
            }, function () {
                _this.props.eventEmitter.emit('select', _this.props.file, _this.state.isChecked);
            });
        };
        return _this;
    }
    /* Component Lifecycle Methods - begin */
    PackageFile.prototype.componentDidMount = function () {
        var props = this.props;
        if (props.packageSize > 0 && (!props.asperaEnabled && props.downloadEnabled) && props.rootLevel) {
            if (!props.file.isLeaf && props.packageSize > utils_1.megabytesToBytes(props.downloadSizeLimitInMB)) {
                this.props.eventEmitter.emit('expand', this.props.file, false);
            }
        }
    };
    PackageFile.prototype.componentDidUpdate = function (prevProps) {
        var props = this.props;
        if (prevProps.asperaEnabled !== props.asperaEnabled || prevProps.downloadEnabled !== props.downloadEnabled) {
            if (!props.file.isLeaf && !props.file.children) {
                if (props.packageSize > 0 && (!props.asperaEnabled && props.downloadEnabled) && props.rootLevel) {
                    if (!props.file.isLeaf && props.packageSize > utils_1.megabytesToBytes(props.downloadSizeLimitInMB)) {
                        this.props.eventEmitter.emit('expand', this.props.file, false);
                    }
                }
            }
        }
    };
    /* Component Methods - end */
    PackageFile.prototype.render = function () {
        var _this = this;
        // Component properties
        var props = this.props;
        /* Package Files constants */
        var folderIconClass = props.file.isLeaf ? 'fa-file' : 'fa-folder';
        var indentIconClass = (props.containsFolders && props.file.isLeaf) ? 'indented' : '';
        var isFileTransferComplete = props.file.state === models_1.PackageTransferState.COMPLETE;
        var isFileTransferCompleteRemoved = props.file.state === models_1.PackageTransferState.REMOVED && props.file.size === props.file.transferredBytes;
        var toggleIconClass = props.file.isLoading ? 'fa-spinner fa-spin' :
            props.file.isCollapsed ? 'fa-plus-square' : 'fa-minus-square';
        var fileSize;
        if (props.file.isLeaf || (!props.file.isLeaf && !props.file.children)) {
            fileSize = props.file.size;
        }
        else {
            var children = props.file.children || [];
            fileSize = children === null || children === void 0 ? void 0 : children.map(function (f) { return f.size; }).reduce(function (sum, current) { return sum + current; }, 0);
            var fileContainsFolders_1 = false;
            children.forEach(function (f) {
                if (!f.isLeaf) {
                    fileContainsFolders_1 = true;
                }
            });
            if (fileContainsFolders_1) {
                fileSize += utils_1.megabytesToBytes(props.downloadSizeLimitInMB);
            }
        }
        var encryptedMsg = props.encryptedPackage ? "Encrypted packages cannot be downloaded without the Aspera Connect plugin enabled." : '';
        var exceededDownloadSizeLimit = !props.asperaEnabled && props.downloadEnabled && (fileSize > utils_1.megabytesToBytes(props.downloadSizeLimitInMB) ||
            (fileSize === 0 && props.packageSize > utils_1.megabytesToBytes(props.downloadSizeLimitInMB)) ||
            props.encryptedPackage);
        var exceededDSLMsg = (fileSize > utils_1.megabytesToBytes(props.downloadSizeLimitInMB) || (fileSize === 0 && props.packageSize > utils_1.megabytesToBytes(props.downloadSizeLimitInMB))) ?
            "Files greater than " + filesize_1.default(utils_1.megabytesToBytes(props.downloadSizeLimitInMB)) + " can't be downloaded without the Aspera Connect plugin." : '';
        var hasBothMsgs = encryptedMsg && exceededDSLMsg ? '\n' : '';
        var downloadIcon = exceededDownloadSizeLimit ? 'fa-exclamation-triangle' : (props.file.isLeaf || props.asperaEnabled ? 'fa-cloud-download-alt' : 'fa-file-archive');
        /* Package File functions - Begin */
        // Checks that the file's size doesn't exceed the download size limit
        var checkDownload = function (e) {
            e.stopPropagation();
            if (!exceededDownloadSizeLimit) {
                _this.handleDownload(props.file);
            }
        };
        /* Package File functions - End */
        /* Define elements used - begin */
        var downloadFileButton = react_1.default.createElement("div", { className: classnames_1.default('tooltip', { 'is-tooltip-left': exceededDownloadSizeLimit }, { prewrap: hasBothMsgs }), "data-tooltip": (exceededDownloadSizeLimit) ? "" + encryptedMsg + hasBothMsgs + exceededDSLMsg : "Download " + (props.file.isLeaf ? 'File' : 'Folder as ZIP') },
            react_1.default.createElement("a", { className: classnames_1.default('download-button', { disabled: (exceededDownloadSizeLimit ||
                        props.file.state === models_1.PackageTransferState.IN_PROGRESS) }), onClick: checkDownload },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("i", { className: "fas " + downloadIcon + " fa-lg" })),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null, "Download"))));
        var downloadFileOpenButton = react_1.default.createElement("div", { className: classnames_1.default('tooltip'), "data-tooltip": 'Open File' },
            react_1.default.createElement("a", { className: "download-button is-orange", onClick: function () { return props.onOpenDownload(props.file); } },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("i", { className: "fas fa-folder-open fa-lg" })),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null, "Open"))));
        var downloadFilePauseButton = react_1.default.createElement(PauseButton_1.PauseButton, { disabled: false, onDownloadStop: function () { return _this.handleDownloadStop(props.file); }, showTooltip: true, tooltipPosition: 'is-tooltip-left' });
        var downloadFileResumeButton = react_1.default.createElement(RetryButton_1.RetryButton, { disabled: false, icon: 'fa-play', onDownload: function () { return _this.handleDownload(props.file); }, showTooltip: true, tooltipMessage: 'Resume Transfer', tooltipPosition: 'is-tooltip-left' });
        var fileProgressDetails = react_1.default.createElement(PackageProgressDetails_1.PackageProgressDetails, { totalBytes: props.file.size, transferredBytes: props.file.transferredBytes });
        // Determine correct state for the download button
        var downloadButton;
        if (props.downloadEnabled) {
            if ((props.file.state === models_1.PackageTransferState.FAILED || props.file.state === models_1.PackageTransferState.STOPPED)) {
                downloadButton =
                    react_1.default.createElement(react_1.default.Fragment, null,
                        downloadFileResumeButton,
                        fileProgressDetails);
            }
            else if (props.asperaEnabled && props.file.state === models_1.PackageTransferState.IN_PROGRESS) {
                downloadButton =
                    react_1.default.createElement(react_1.default.Fragment, null,
                        downloadFilePauseButton,
                        fileProgressDetails);
            }
            else if (props.asperaEnabled && (isFileTransferComplete || isFileTransferCompleteRemoved)) {
                downloadButton = downloadFileOpenButton;
            }
            else {
                downloadButton = downloadFileButton;
            }
        }
        var errorMessage = (props.file.errorMsg ?
            ((props.file.errorDesc) ? props.file.errorMsg + " - " + props.file.errorDesc : props.file.errorMsg) :
            '');
        /* Define elements used - begin */
        return (react_1.default.createElement("div", { className: "package-file" },
            react_1.default.createElement("div", { className: "panel-block" },
                react_1.default.createElement("div", { className: "level is-mobile" },
                    react_1.default.createElement("div", { className: "level-left" },
                        react_1.default.createElement("div", { className: "level-item" },
                            !props.file.isLeaf &&
                                react_1.default.createElement("span", { className: "icon toggle-icon", onClick: this.handleExpand },
                                    react_1.default.createElement("i", { className: classnames_1.default('fas', toggleIconClass) })),
                            react_1.default.createElement("div", { className: "field", onClick: this.handleSelect },
                                react_1.default.createElement("label", { title: props.file.name },
                                    react_1.default.createElement("i", { className: classnames_1.default('fas', folderIconClass, indentIconClass) }),
                                    " ",
                                    props.file.name)))),
                    react_1.default.createElement("div", { className: "level-right" },
                        react_1.default.createElement("div", { className: "level-item item-file-size" }, props.file.isLeaf &&
                            react_1.default.createElement("div", { className: "help" }, filesize_1.default(props.file.size))),
                        react_1.default.createElement("div", { className: "level-item has-text-centered is-4" }, downloadButton))),
                react_1.default.createElement("div", { className: "level" },
                    react_1.default.createElement("div", { className: "level-item" }, props.file.state && props.fileStatus &&
                        react_1.default.createElement("div", { className: "download-progress" },
                            react_1.default.createElement("div", { className: "download-error help is-danger" }, errorMessage),
                            react_1.default.createElement(PackageProgressBar_1.PackageProgressBar, { state: props.file.state, transferredBytes: props.file.transferredBytes, totalBytes: props.file.size }))))),
            props.file.children && !props.file.isCollapsed &&
                exports.loop(props.file.children, props.eventEmitter, props.asperaEnabled, props.downloadEnabled, props.downloadSizeLimitInMB, props.encryptedPackage, props.fileStatus, props.httpGatewayStatus, props.onDownload, props.onOpenDownload, props.onRetry, props.onStop, props.packageSize, false)));
    };
    return PackageFile;
}(react_1.Component));
exports.PackageFile = PackageFile;
